import axios from "axios";
import { BASE_URL } from "../API/Constants"

const axiosInstance = axios.create({
  baseURL: BASE_URL, // "http://localhost:3000/"
});

// ✅ Automatically attach token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // ✅ Token expired or unauthorized -> logout
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("jwt");
      localStorage.removeItem("accessToken");
      
      // Force redirect to home page
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
